import React from "react";
import { Form, Input, Row, Col, Checkbox, Button, message } from "antd";
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { setRemember } from "../../utils/Session";
import Net from "../../utils/net";
import config from "../../config";
import CryptoJS from "crypto-js";
import SHA256 from "crypto-js/sha256";
import "./style.css";

export default class Login extends React.Component {
    state = {
        focusItem: -1,//保存当前聚焦的input
        code: "",//验证码
        username: "",
        password: "",
        autoLogin: true
    };

    componentDidMount() {
    }

    loginSubmit = (e) => {
        e.preventDefault();
        this.setState({
            focusItem: -1
        });
        this.formRef.validateFields().then(values => {
            let password = SHA256(values.username + values.password).toString(CryptoJS.enc.Hex);
            Net.post(global.ServerUrl + 'user/login', { loginName: values.username, password: password }, res => {
                console.log("login", res);
                if (0 === res.result) {
                    if (this.state.autoLogin) {
                        setRemember({
                            autoLogin: this.state.autoLogin,
                            autoLoginTime: new Date().getTime(),
                            user: res.ret
                        });
                    }
                    global.loginUser = res.ret;
                    window.token = global.loginUser.token;
                    this.goHome();
                } else {
                    message.error("用户名或密码错误，登录失败！");
                }
            }, error => {
                console.log('loginSubmit', error);
                message.error("连接服务器失败，请重新登录！");
            });
        }).catch(errorInfo => {
            console.log(errorInfo);
        })
    };
    onFinish = (values) => {
        console.log("onFinish", values)
        if (values.loginName === "" || values.password === "") {
            return message.warning("请输入用户名/密码");
        }
        this.loginSubmit(values);
    };
    goHome = () => {
        this.props.history.push({ pathname: "/sys/home" });
    };
    changeCheck = (e) => {
        this.setState({ autoLogin: e.target.checked })
    };

    render() {
        const { code } = this.state;
        return (
            <div style={{
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                position: 'fixed', width: '100%', height: '100%', zIndex: 99,
            }} className="wrap">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <div style={{ minWidth: 500, width: '40%', margin: '0 auto', }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div id="loginForm" style={{
                                backgroundColor: '#F8F8F8'
                            }}
                            >
                                <div style={{ padding: '10px 20px', fontSize: 15, color: '#000', fontWeight: 'bold', backgroundColor: '#EEE', textAlign: "center" }}>
                                    欢迎进入{config.title}，请登录！
                                </div>
                                <Form style={{ padding: 40, }}
                                    ref={comp => this.formRef = comp}
                                    // onFinish={this.onFinish}
                                    onSubmit={this.loginSubmit}>
                                    <Form.Item style={{ marginBottom: 15 }}
                                        name="username"
                                        rules={[{ required: true, message: "请输入用户名" }]}
                                    >
                                        <Input
                                            onFocus={() => this.setState({ focusItem: 0 })}
                                            onBlur={() => this.setState({ focusItem: -1 })}
                                            maxLength={16}
                                            placeholder="请输入用户名"
                                            addonBefore={<UserOutlined />}
                                        />
                                    </Form.Item>
                                    <Form.Item style={{ marginBottom: 15 }}
                                        name="password"
                                        rules={[{ required: true, message: "请输入密码" }]}>
                                        <Input
                                            onFocus={() => this.setState({ focusItem: 1 })}
                                            onBlur={() => this.setState({ focusItem: -1 })}
                                            type="password"
                                            maxLength={16}
                                            placeholder="请输入密码"
                                            addonBefore={<LockOutlined />}
                                        />
                                    </Form.Item>
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item style={{ marginBottom: 15 }} name="autoLogin">
                                                <Checkbox onChange={this.changeCheck} checked={this.state.autoLogin} style={{ color: "#424242" }}>自动登录</Checkbox>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <div className="bottom">
                                        <Button htmlType="submit" type="primary"
                                            style={{
                                                width: '100%', height: 40, backgroundColor: '#096dd9',
                                                color: '#FFF', border: 'none'
                                            }}
                                            onClick={(e) => this.loginSubmit(e)}>登录</Button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ position: "absolute", top: 0, right: 5, color: "#FFF", }}>版本：{config.version}</div>
            </div>
        )
    }
}
